import styled, { css, keyframes } from 'styled-components';

export const SelectWrap = styled.div`
  position: relative;
  user-select: none;
  width: 180px;
  cursor: var(--hoverCursorURL), pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const disabledTriggerStyle = css`
  opacity: 0.5;
  cursor: not-allowed;
`;

const selectSizeMap = {
  xl: css``,
  md: css`
    height: 40px;
    padding: 0 12px;
    font-size: 14px;
  `,
  sm: css`
    height: 32px;
    padding: 0 8px;
    font-size: 14px;
  `,
};

export const SelectTrigger = styled.div<{
  disabled?: boolean;
  size: 'xl' | 'md' | 'sm';
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--cardBackgroundColor);
  border: 1px solid var(--lineColor);
  cursor: var(--hoverCursorURL), pointer;
  border-radius: var(--cardBorderRadius);
  backdrop-filter: blur(8px);

  ${({ size }) => size && selectSizeMap[size]};
  ${({ disabled }) => disabled && disabledTriggerStyle}
`;

export const SelectValueWrap = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const ArrowIcon = styled.div<{
  isSelectOpen: boolean;
  color?: string;
}>`
  position: relative;
  height: 10px;
  width: 10px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 0.15rem;
    height: 100%;
    transition: all 0.2s;
    background-color: ${({ color }) => color || `var(--textColor)`};
  }

  &::before {
    left: 3px;
    transform: ${({ isSelectOpen }) =>
      isSelectOpen ? 'rotate(-45deg)' : 'rotate(45deg)'};
  }

  &::after {
    left: -3px;
    transform: ${({ isSelectOpen }) =>
      isSelectOpen ? 'rotate(45deg)' : 'rotate(-45deg)'};
  }
`;

export const Options = styled.div<{
  isActiveIndex: boolean;
}>`
  padding: 6px 8px;
  display: flex;
  text-align: left;

  background-color: ${({ isActiveIndex }) =>
    isActiveIndex && 'var(--inkColor)'};
  border-radius: var(--cardBorderRadius);

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    background-color: var(--inkColor);
  }
`;

export const DropdownDescription = styled.div`
  font-size: 13px;
  color: var(--subTextColor);
  margin-top: 4px;
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

export const SpinnerIcon = styled.div`
  width: 12px;
  height: 12px;
  border: 2px solid var(--lineColor);
  border-top-color: var(--textColor);
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  flex-shrink: 0;
`;
